import { UI_STATES } from '../../constants/commonConstants.js';
import {
    GET_BASIC_SETTINGS,
    GET_BASIC_SETTINGS_SUCCESS,
    GET_BASIC_SETTINGS_FAIL,
    EDIT_BASIC_SETTINGS,
    EDIT_BASIC_SETTINGS_SUCCESS,
    EDIT_BASIC_SETTINGS_FAIL,
} from '../../constants/switchConfiguration/basicSettingsConstant.js';

/**
 * Reducer function for managing basic Settings data state.
 *
 * This reducer handles actions related to fetching basic Settings data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the basic Settings.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const basicSettingsReducer = (state = { settingsData: {} }, action) => {
    switch (action.type) {
        case GET_BASIC_SETTINGS:
            return {
                loading: true,
            };
        case GET_BASIC_SETTINGS_SUCCESS:
            return {
                loading: false,
                settingsData: action.payload,
            };
        case GET_BASIC_SETTINGS_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
            
        default:
            return state;
    }
};
export const basicSettingsUpdateReducer = (
	state = { status: null, error: null, data: [] },
	action
) => {
	switch (action.type) {
		case EDIT_BASIC_SETTINGS:
			return {
				...state,
				status: UI_STATES.LOADING,
				error: null,
			};
		case EDIT_BASIC_SETTINGS_SUCCESS:
			return {
				...state,
				status: UI_STATES.SUCCESS,
				data: action.payload,
			};
		case EDIT_BASIC_SETTINGS_FAIL:
			return {
				...state,
				status: UI_STATES.FAILURE,
				error: action.payload,
			};
		
		default:
			return state;
	}
};
